import { isRouteErrorResponse, useRouteError } from 'react-router'
import { Button } from '@/components/base/buttons/button'

/** PRD-018 §3.10: an error state is text with a way out, never a stack trace. */
export function RouteError() {
  const err = useRouteError()
  const chunk = err instanceof Error && /dynamically imported module|Loading chunk|Importing a module script failed/i.test(err.message)
  const title = chunk ? 'Gallop was updated while this tab was open' : isRouteErrorResponse(err) ? `${err.status} ${err.statusText}` : 'Something went wrong on this page'
  const body = chunk ? 'Reload to pick up the new version. Nothing you entered on other pages is lost.' : 'Reload the page. If it happens again, tell the Palomino team what you were doing.'
  return (
    <main role="alert" className="mx-auto flex max-w-md flex-col gap-3 px-8 py-16 text-sm">
      <h1 className="text-lg font-semibold text-primary">{title}</h1>
      <p className="text-tertiary">{body}</p>
      <div><Button color="primary" size="md" onClick={() => window.location.reload()}>Reload</Button></div>
    </main>
  )
}
